module.exports = __webpack_public_path__ + "img/02.388fc83e.png";